export interface ConfiguratorDefinitionErrorContext {
  productCode: string;
  stepIndex?: number;
  stepId?: string;
  substepIndex?: number;
  controlIndex?: number;
  instanceId?: string;
  csticName?: string;
}

const formatContext = (context: ConfiguratorDefinitionErrorContext) =>
  [
    `product=${context.productCode}`,
    context.stepIndex === undefined ? null : `step=${context.stepIndex}`,
    context.stepId ? `stepId=${context.stepId}` : null,
    context.substepIndex === undefined ? null : `substep=${context.substepIndex}`,
    context.controlIndex === undefined ? null : `control=${context.controlIndex}`,
    context.instanceId ? `instance=${context.instanceId}` : null,
    context.csticName ? `cstic=${context.csticName}` : null,
  ]
    .filter(Boolean)
    .join(", ");

export class ConfiguratorDefinitionError extends Error {
  constructor(
    message: string,
    readonly context: ConfiguratorDefinitionErrorContext,
  ) {
    super(`${message} (${formatContext(context)})`);
    this.name = "ConfiguratorDefinitionError";
  }
}
